import { createSelector } from '@reduxjs/toolkit';
import { employeesNotDeleted } from '../employees/employees-not-deleted';
import { issuesRecipientsForCore } from './issues-recipients-for-core';
import { getOrganization } from '../organization/getOrganization';
import { functionsNotDeleted } from '../responsibilities/functions-not-deleted';
import type { SelectDropdownOption } from '../../../library/editors/elements/select-dropdown-option';
import { getFeatureStates } from '../features/getFeatureStates';

export const getRecipientOptionsForIssues = createSelector(
  getOrganization,
  functionsNotDeleted,
  employeesNotDeleted,
  getFeatureStates,
  (organization, functions, employees, featureStates): SelectDropdownOption[] => {
    if (featureStates.core) {
      return issuesRecipientsForCore(functions, employees, organization);
    } else {
      return employees.filter((e) => e.accessLevel === 'USER').map((e) => ({ value: e.uuid, text: e.name }));
    }
  },
);
